export const SENSOR_TYPE = {
    FLUVIOGRAPH: 1,
    ANEMOCLINOGRAPH: 2,
    CAMERA: 3,
}

export function getSensorTypeName(type: number) {
    if (type === SENSOR_TYPE.FLUVIOGRAPH) {
        return "水位计"
    } else if (type === SENSOR_TYPE.ANEMOCLINOGRAPH) {
        return "风速风向仪"
    } else if (type === SENSOR_TYPE.CAMERA) {
        return "摄像头"
    }
    return ''
}

export const SENSOR_TYPE_LIST = [
    { value: SENSOR_TYPE.FLUVIOGRAPH, label: '水位计' },
    { value: SENSOR_TYPE.ANEMOCLINOGRAPH, label: '风速风向仪' },
    { value: SENSOR_TYPE.CAMERA, label: '摄像头' },
]

/**
 * 传感器数据库表名
 */
export const SENSOR_TABLE_NAME = 'sensor';

export const SENSOR_MODEL_TYPE = {
    1: 'fluviograph',
    2: 'anemoclinograph',
    3: 'monitor',
}